import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';

import EnhancedTab from '../../../../lib/designSystem/TabSimulation';
import CenteredCircularProgress from '../../../../lib/designSystem/CircularProgress';
import ProductsSummary from './components/PendingAccountsCategories';
import Funds from './components/Funds';
import CollectionStates from './components/CollectionStates';
import CollectionFlows from './components/CollectionFlows';
import {
  validateCompanyTypes,
  validatePermissions,
} from '../../../../lib/functions/utils';
import { AuthState } from '../../../../services/redux/authSlice';
import { useSelector } from 'react-redux';

const tabs = [
  {
    index: 0,
    label: 'Categorías de cobranza',
    component: <CollectionStates />,
    path: 'collectionsStates',
  },
  {
    index: 1,
    label: 'Cuentas',
    component: <ProductsSummary />,
    path: 'accounts',
  },
  {
    index: 2,
    label: 'Fondos',
    component: <Funds />,
    path: 'funds',
  },
  {
    index: 3,
    label: 'Flujos de cobranza',
    component: <CollectionFlows />,
    path: 'collectionFlows',
  },
];

const FinanceTab = () => {
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const { subPage } = useParams<{
    id: string;
    businessId: string;
    subPage: string;
    page: string;
  }>();
  const [loading, setLoading] = useState(false);
  const [companyTabs, setCompanyTabs] = useState<any>([]);
  const navigate = useNavigate();

  const [startValue, setStartValue] = useState(0);
  const handleNavigation = (index: number) => {
    navigate(`/settings/finance/${companyTabs[index].path}`);
  };

  const setUpTabs = async () => {
    setLoading(true);
    const availableTabs: any = [];
    if (validateCompanyTypes(user, 'Accountant')) {
      availableTabs.push(tabs[0]);
      availableTabs.push(tabs[3]);
    } else {
      if (validatePermissions(user, 'settings_collections')) {
        availableTabs.push(tabs[0]);
        availableTabs.push(tabs[3]);
      }
      if (validatePermissions(user, 'settings_funds')) {
        availableTabs.push(tabs[2]);
      }
      if (validatePermissions(user, 'settings_pending_accounts')) {
        availableTabs.push(tabs[1]);
      }
    }
    let startValueDefault = 0;
    startValueDefault = availableTabs.findIndex((x: any) => x.path === subPage);
    setCompanyTabs(availableTabs);
    setStartValue(startValueDefault === -1 ? 0 : startValueDefault);
    setLoading(false);
  };

  useEffect(() => {
    setUpTabs();
  }, []);
  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <EnhancedTab
        tabType="secondary"
        startValue={startValue}
        tabs={companyTabs}
        onTabChange={handleNavigation}
        // canShowTab={checkCanAccessView()}
      />
    </div>
  );
};

export default FinanceTab;
